<template>
  <v-container>
    <v-row>
      <!-- <v-col cols="12">
        <module-bar title="NOTAS RAPIDAS"> </module-bar>
      </v-col> -->

      <v-col cols="12" md="6">
        <v-card outlined>
          <v-card-title>
            <v-icon class="mr-2">mdi-note-text</v-icon>
            Categorias 

            <v-spacer />
            <v-btn v-if="categoryId > 0" icon color="primary" @click="openDialogCategory('edit')"><v-icon
                size="18">mdi-pencil</v-icon></v-btn>
            <v-btn icon color="primary" @click="openDialogCategory('new')">
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </v-card-title>

          <v-card-text>
            <v-col class="d-flex justify-center" v-if="loadingCategories">
              <v-progress-circular indeterminate width="2" size="60" color="primary" />
            </v-col>
            <v-list max-height="400" class="overflow-y-auto" v-if="loadedCategories">
              <v-list-item-group color="primary">
                <template v-for="(item, key) in categories">
                  <v-list-item @click="selectCategory(item.id)" :key="key" v-if="categories">
                    <v-list-item-content>
                      <v-list-item-title>
                        {{ item.name }}
                      </v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action>
                      <v-progress-circular indeterminate color="primary" width="2" size="20"
                        v-if="loadingNotes && categoryId == item.id" :key="key" />
                    </v-list-item-action>
                  </v-list-item>
                  <v-divider v-if="key != categories.length - 1" :key="`div${key}`" />
                </template>
              </v-list-item-group>
            </v-list>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- notas -->
      <v-col cols="12" md="6">
        <v-card outlined class="" :loading="loadingNotes">
          <v-card-title>
            <v-icon class="mr-2">mdi-note-text-outline</v-icon>
            Notas
            <v-spacer />
            <v-btn v-if="categoryId >= 0" icon color="primary" @click="openDialogNote('new')">
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <v-list max-height="400" class="overflow-y-auto">
              <v-list-item-group color="primary">
                <template v-for="(item, key) in notes">
                  <v-list-item @click="selectNote(item.id)" :key="key" v-if="notes">
                    <v-list-item-content>
                      <v-list-item-title>
                        {{ item.name }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider v-if="key != notes.length - 1" :key="`div${key}`" />
                </template>
              </v-list-item-group>
            </v-list>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- agenda -->
      <v-col cols="12">
        <v-card outlined>
          <v-card-title>
            <v-icon class="mr-2">mdi-calendar-month-outline</v-icon>
            Agenda
            <v-spacer />
            <v-btn icon @click="showCalendar = !showCalendar">
              <v-icon>
                {{ showCalendar ? "mdi-chevron-up" : "mdi-chevron-down" }}
              </v-icon>
            </v-btn>
          </v-card-title>
          <v-expand-transition>
            <div v-show="showCalendar">
              <v-card-text>
                <calendar />
              </v-card-text>
            </div>
          </v-expand-transition>
        </v-card>
      </v-col>

      <!-- //totales del cierre -->
      <v-col cols="12">
        <v-card outlined>
          <v-card-title>
            <v-icon class="mr-2">mdi-chart-sankey</v-icon>
            Totales del cierre
            <v-spacer />
            <v-btn icon @click="showReportTotal = !showReportTotal">
              <v-icon>
                {{ showReportTotal ? "mdi-chevron-up" : "mdi-chevron-down" }}
              </v-icon>
            </v-btn>
          </v-card-title>
          <v-expand-transition>
            <div v-show="showReportTotal">
              <v-card-text>
                <report-close />
              </v-card-text>
            </div>
          </v-expand-transition>
        </v-card>
      </v-col>

      <v-col cols="12">
        <v-card outlined>
          <v-card-title>
            <v-icon class="mr-2">mdi-car-cruise-control</v-icon>
            Misiones
            <v-spacer />
            <v-btn icon @click="showMissions = !showMissions">
              <v-icon>
                {{ showMissions ? "mdi-chevron-up" : "mdi-chevron-down" }}
              </v-icon>
            </v-btn>
          </v-card-title>
          <v-expand-transition>
            <div v-show="showMissions">
              <v-card-text>
                <admin-mission :withTitle="false" />
              </v-card-text>
            </div>
          </v-expand-transition>
        </v-card>
      </v-col>


      <!-- estadisticas -->
      <v-col cols="12" md="12">
        <v-card outlined>
          <v-card-title>
            <v-icon class="mr-2">mdi-chart-bar</v-icon>
            Estadisticas
            <v-spacer />
            <v-btn icon @click="showStatistics = !showStatistics">
              <v-icon>
                {{ showStatistics ? "mdi-chevron-up" : "mdi-chevron-down" }}
              </v-icon>
            </v-btn>
          </v-card-title>
          <v-expand-transition>
            <div v-show="showStatistics">
              <v-card-text>
                <v-row>
                  <!-- gota -->
                  <v-col cols="12" md="12">
                    <v-list outlined color="#385F73" dark>
                      <v-list-item-group color="gray">
                        <v-list-item @click="amountPaymentMethod">
                          <v-list-item-content>
                            <v-list-item-title>
                              MONTO PAGADO:
                            </v-list-item-title>
                          </v-list-item-content>
                          <v-list-item-action>
                            <v-progress-circular v-if="loadingAmountCharge" indeterminate color="white" width="1"
                              size="20" />
                            <div style="font-size: 1.5em" v-if="loadedAmountCharge">
                              {{ amountCharge }} USDT
                            </div>
                          </v-list-item-action>
                        </v-list-item>
                        <v-divider />
                        <!-- <v-list-item>
                          <v-list-item-content>
                            <v-list-item-title>
                              MONTO FALTANTE:
                            </v-list-item-title>
                          </v-list-item-content>
                          <v-list-item-action>
                            <v-progress-circular v-if="loadingAmountReceivable" indeterminate color="white" width="1"
                              size="20" />
                            <div style="font-size: 1.5em" v-if="loadedAmountReceivable">
                              {{ amountReceivable }} S/
                            </div>
                          </v-list-item-action>
                        </v-list-item> -->
                        <v-list-item @click="vehiculeFindAdminMethod">
                          <v-list-item-content>
                            <v-list-item-title>
                              VEHICULOS VERIFICADOS POR ADMINISTRADOR:
                            </v-list-item-title>
                          </v-list-item-content>
                          <v-list-item-action>
                            <v-progress-circular v-if="loadingVehiculeFindAdmin" indeterminate color="white" width="1"
                              size="20" />
                            <div style="font-size: 1.5em" v-if="loadedVehiculeFindAdmin">
                              {{ vehiculesFindAdmin }} VEHICULOS
                            </div>
                          </v-list-item-action>
                        </v-list-item>
                        <v-divider />
                        <v-list-item @click="countVehiculeVerifiedMethod">
                          <v-list-item-content>
                            <v-list-item-title>
                              VEHICULOS VERIFICADOS HOY EN APP MOVIL:
                            </v-list-item-title>
                          </v-list-item-content>
                          <v-list-item-action>
                            <v-progress-circular v-if="loadingVerified" indeterminate color="white" width="1"
                              size="20" />
                            <div style="font-size: 1.5em" v-if="loadedVerified">
                              {{ countVehiculeVerified }} VEHICULOS
                            </div>
                          </v-list-item-action>
                        </v-list-item>

                      </v-list-item-group>
                    </v-list>

                    <v-list outlined color="#4e7d95" dark>
                      <v-list-item-group>
                        <v-list-item class="">
                          <v-list-item-content>
                            <v-list-item-title>
                              SUELDOS EMPLEADOS:
                            </v-list-item-title>
                          </v-list-item-content>
                          <v-list-item-action>
                            <v-progress-circular v-if="loadingSalary" indeterminate color="white" width="1" size="20" />
                            <div style="font-size: 1.5em" v-if="loadedSalary">
                              {{ totalSalary }} S/
                            </div>
                          </v-list-item-action>
                        </v-list-item>

                        <v-list-item class="" @click="openDialogAdminPayroll">
                          <v-list-item-content>
                            <v-list-item-title>
                              NOMINAS:
                            </v-list-item-title>
                          </v-list-item-content>
                          <v-list-item-action>
                            <v-progress-circular v-if="loadingPayrollsTotal" indeterminate color="white" width="1"
                              size="20" />
                            <div style="font-size: 1.5em" v-if="loadedPayrollsTotal">
                              {{ payrollsTotal.count_payrolls > 0 ? payrollsTotal.count_payrolls : 0 }} NOMINAS |
                              {{ payrollsTotal.count_employees > 0 ? payrollsTotal.count_employees : 0 }} EMPLEADOS |
                              {{
                                payrollsTotal.sum_salaries > 0 ? payrollsTotal.sum_salaries.toLocaleString("es-PE",
                                  {
                                    style: "currency",
                                    currency: "PEN",
                                  }) : 0
                              }}
                            </div>
                          </v-list-item-action>
                        </v-list-item>

                        <v-list-item class="" @click="openDialogTotalRent">
                          <v-list-item-content>
                            <v-list-item-title>
                              ALQUILERES:
                            </v-list-item-title>
                          </v-list-item-content>
                          <v-list-item-action>
                            <v-progress-circular v-if="loadingRent" indeterminate color="white" width="1" size="20" />
                            <div style="font-size: 1.5em" v-if="loadedRent">
                              {{ amountRent > 0 ? amountRent.toLocaleString("es-PE", {
                                style: "currency",
                                currency: "PEN",
                              }) : 0 }} S/
                            </div>
                          </v-list-item-action>
                        </v-list-item>
                      </v-list-item-group>
                    </v-list>
                  </v-col>

                  <!-- vehiculos y herramientas -->
                  <v-col cols="12" md="6">
                    <v-list outlined color="#952175" dark>
                      <v-list-item-group color="gray">
                        <v-list-item @click="openDialogStadits('vehicule_public')">
                          <v-list-item-content>
                            <v-list-item-title>
                              CARROS / CAMIONETAS:
                            </v-list-item-title>
                          </v-list-item-content>
                          <v-list-item-action>
                            <v-progress-circular v-if="loadingVehiculePublic" indeterminate color="white" width="1"
                              size="20" />
                            <div style="font-size: 1.5em" v-if="loadedVehiculePublic">
                              {{ countVehiculePublic }}
                            </div>
                          </v-list-item-action>
                        </v-list-item>
                        <v-divider />
                        <v-list-item @click="openDialogStadits('vehicule_private')">
                          <v-list-item-content>
                            <v-list-item-title>
                              MOTOS:
                            </v-list-item-title>
                          </v-list-item-content>
                          <v-list-item-action>
                            <v-progress-circular v-if="loadingVehiculePrivate" indeterminate color="white" width="1"
                              size="20" />
                            <div style="font-size: 1.5em" v-if="loadedVehiculePrivate">
                              {{ countVehiculePrivate }}
                            </div>
                          </v-list-item-action>
                        </v-list-item>
                        <v-divider />
                        <v-list-item @click="openDialogStadits('tools')">
                          <v-list-item-content>
                            <v-list-item-title>
                              HERRAMIENTAS:
                            </v-list-item-title>
                          </v-list-item-content>
                          <v-list-item-action>
                            <v-progress-circular v-if="loadingCountTool" indeterminate color="white" width="1"
                              size="20" />
                            <div style="font-size: 1.5em" v-if="loadedCountTool">
                              {{ countTools }}
                            </div>
                          </v-list-item-action>
                        </v-list-item>
                      </v-list-item-group>
                    </v-list>
                  </v-col>

                  <!-- empleados -->
                  <v-col cols="12" md="6">
                    <v-list color="#4C762E" dark>
                      <v-list-item @click="openDialogEmployees('enabled')">
                        <v-list-item-title>
                          EMPLEADOS ACTIVOS
                        </v-list-item-title>
                        <v-list-item-action>
                          <v-progress-circular v-if="loadingCountEmployee" indeterminate color="white" width="1"
                            size="20" />
                          <div style="font-size: 1.5em" v-if="loadedCountEmployee">
                            {{ countEmployees.enabled }}
                          </div>
                        </v-list-item-action>
                      </v-list-item>
                    </v-list>

                    <v-list color="#ee4517" dark class="mt-2">
                      <v-list-item @click="openDialogEmployees('disabled')">
                        <v-list-item-title>
                          EMPLEADOS INACTIVOS
                        </v-list-item-title>
                        <v-list-item-action>
                          <v-progress-circular v-if="loadingCountEmployee" indeterminate color="white" width="1"
                            size="20" />
                          <div style="font-size: 1.5em" v-if="loadedCountEmployee">
                            {{ countEmployees.disabled }}
                          </div>
                        </v-list-item-action>
                      </v-list-item>
                    </v-list>
                  </v-col>

                  <!-- <v-col cols="6">
                    <v-card >

                    </v-card>
                  </v-col> -->

                  <v-col cols="6">
                    <employee-category-chart />
                  </v-col>

                  <v-col cols="6">
                    <vehicule-category-chart />
                  </v-col>

                  <!-- <v-col cols="6">
                    <v-card outlined>

                    </v-card>
                  </v-col> -->
                </v-row>
              </v-card-text>
            </div>
          </v-expand-transition>
        </v-card>
      </v-col>

      <!-- mapa -->
      <v-col cols="12">
        <v-card outlined>
          <v-card-title><v-icon class="mr-2">mdi-map</v-icon> Mapa de Peru
            <v-spacer />
            <v-btn icon @click="showMap = !showMap">
              <v-icon>
                {{ showMap ? "mdi-chevron-up" : "mdi-chevron-down" }}
              </v-icon>
            </v-btn>
          </v-card-title>
          <v-expand-transition>
            <div v-show="showMap">
              <v-card-text>
                <Map></Map>
              </v-card-text>
            </div>
          </v-expand-transition>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog v-model="dialogCategory" max-width="600" persistent>
      <v-card outlined>
        <v-card-title>{{ titleDialogCategory }}</v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-text-field label="Nombre de la categoria" v-model="categoryName" />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn :loading="loadingDelete" text color="red" v-if="this.btnCategory == 'EDITAR'"
            @click="deleteCategory">eliminar</v-btn>
          <v-spacer />
          <v-btn text @click="closeDialogCategory">cancelar</v-btn>
          <v-divider vertical class="ml-2 mr-2" />
          <v-btn text color="primary" @click="processCategory" :loading="loadingProcessCategory">{{ btnCategory
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogNote" max-width="600">
      <v-card>
        <v-card-title>{{ titleDialogNote }}</v-card-title>
        <v-card-text>
          <v-col cols="12" class="d-flex justify-center mt-10" v-if="loadingNote">
            <v-progress-circular indeterminate color="primary" width="2" size="60" />
          </v-col>
          <v-row v-if="loadedNote">
            <v-col :cols="visibleNoteUpdatedAt ? '6' : '12'">
              <v-text-field label="Nombre de la nota" v-model="noteName" />
            </v-col>

            <v-col cols="6" v-if="visibleNoteUpdatedAt">
              <v-select v-model="noteCategoryId" :items="categories" item-text="name" item-value="id"
                label="Categoria" />
            </v-col>

            <v-col cols="12" v-if="!isList">
              <v-textarea height="400" label="Contenido" v-model="noteContent" outlined />
            </v-col>

            <div v-if="visibleNoteUpdatedAt">
              <v-subheader>Ultima edicion el {{ noteUpdateAt }}</v-subheader>
            </div>
          </v-row>
        </v-card-text>

        <v-card-actions v-if="loadedNote">
          <v-btn :loading="loadingDeleteNote" v-if="isDelete" @click="deleteNote" text color="red">eliminar</v-btn>
          <v-spacer />
          <v-btn text @click="closeDialogNote">cancelar</v-btn>
          <v-btn text @click="processNote" :loading="loadingProcessNote" color="primary">
            {{ btnDialogNote }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogStadits" width="800">
      <v-card>
        <v-card-text>
          <admin-vehicule :type="valueStadits" schema="dash" :click_dash="click_dash" />
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogTools" width="800">
      <v-card>
        <v-card-text>
          <admin-tool :type="valueStadits" schema="dash" :click_tool="click_tool" />
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogClosing" width="1200">
      <v-card>
        <v-card-title> Lista de movimientos </v-card-title>
        <v-card-text>
          <v-row v-if="loadingMovements">
            <v-col cols="12" class="d-flex justify-center">
              <v-progress-circular indeterminate color="primary" width="2" size="60" />
            </v-col>
          </v-row>

          <list-movements v-if="loadedMovements" :movements="movements" schema="closed" />
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogEmployee" width="800">
      <v-card>
        <v-card-text>
          <admin-employee :type="typeEmployee" :click="click_employee" />
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogTotalRent" width="800">
      <v-card>
        <v-card-title>ALQUILERES AGRUPADO POR SEMANAS</v-card-title>
        <v-card-text>
          <v-row v-if="loadingTotalRent">
            <v-col class="d-flex justify-center mt-5">
              <v-progress-circular indeterminate color="primary" width="2" size="60" v-if="loadingTotalRent" />
            </v-col>
          </v-row>
          <v-list v-if="totalRent">
            <template v-for="w, key in totalRent">
              <v-list-item :key="key" v-if="totalRent">
                <v-list-item-content>
                  <v-list-item-title>
                    SEMANA {{ w.week }} {{ w.text }}
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    CANTIDAD DE ALQUILERES: {{ w.total_count }}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle>
                    MONTO TOTAL: {{ w.total_amount > 0 ? w.total_amount.toLocaleString("es-PE", {
                      style: "currency",
                      currency: "PEN",
                    }) : 0 }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-divider v-if="totalRent.length - 1 != key" :key="`div${key}`" />
            </template>
          </v-list>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogAdminPayroll" width="1000">
      <v-card>
        <v-card-text>
          <admin-payroll />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text color="primary" @click="closeDialogPayroll">cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-container>
</template>

<script>
import AdminTool from "../../views/Tools/AdminTool.vue";
import AdminEmployee from "../../views/Employees/AdminEmployee.vue";
import AdminVehicule from "../../views/Vehicules/AdminVehicule.vue";
import ListMovements from "../Forms/listMovements.vue";
import Calendar from "../General/Calendar.vue";
import Map from "../Charts/Maps.vue";
import EmployeeCategoryChart from "../Charts/CategoriesEmployees.vue";
import VehiculeCategoryChart from "../Charts/VehiculeCategoryChart.vue";
import ReportClose from "../Forms/reportClose.vue";
import AdminPayroll from "../../views/Payrolls/AdminPayRoll.vue"
import AdminMission from "../../views/Missions/AdminMission.vue";

export default {
  components: { AdminPayroll, Map, Calendar, AdminVehicule, AdminTool, ListMovements, AdminEmployee, EmployeeCategoryChart, ReportClose, VehiculeCategoryChart, AdminMission },

  data() {
    return {
      dialogAdminPayroll: false,
      payrollsTotal: {},
      loadingPayrollsTotal: false,
      loadedPayrollsTotal: false,
      vehiculesFindAdmin: 0,
      loadedVehiculeFindAdmin: false,
      loadingVehiculeFindAdmin: true,
      showReportTotal: false,
      showMissions: false,
      loadingRent: true,
      loadedRent: false,
      amountRent: 0,
      showCalendar: false,
      showMap: true,
      loadingSalary: true,
      loadedSalary: false,
      totalSalary: 0,
      click_employee: 0,
      dialogEmployee: false,
      loadingCountEmployee: true,
      loadedCountEmployee: false,
      countEmployees: 0,
      loadingMovements: true,
      loadedMovements: false,
      movements: [],
      dialogClosing: false,
      closings: [],
      click_tool: 0,
      dialogTools: false,
      click_dash: 0,
      valueStadits: "",
      dialogStadits: false,
      loadingVerified: true,
      loadedVerified: false,
      countVehiculeVerified: 0,
      amountReceivable: 0,
      loadingAmountReceivable: true,
      loadedAmountReceivable: false,
      amountCharge: 0,
      loadingAmountCharge: true,
      loadedAmountCharge: false,
      countVehiculePublic: 0,
      loadingVehiculePublic: true,
      loadedVehiculePublic: false,
      countVehiculePrivate: 0,
      loadingVehiculePrivate: true,
      loadedVehiculePrivate: false,
      countTools: 0,
      countVehicules: 0,
      loadedCountTool: false,
      loadingCountTool: true,
      showStatistics: true,
      loadedNote: false,
      loadingNote: false,
      loadedCategories: false,
      loadingCategories: false,
      loadingDeleteNote: false,
      isDelete: false,
      loadingDelete: false,
      noteCategoryId: 0,
      noteUpdateAt: "",
      loadingProcessNote: false,
      noteContent: "",
      isList: false,
      btnDialogNote: "",
      titleDialogNote: "",
      dialogNote: false,
      titleDialogCategory: "",
      categoryId: 0,
      btnCategory: "",
      dialogCategory: false,
      loadingNotes: false,
      loadingProcessCategory: false,
      categoryName: "",
      noteName: "",
      visibleNoteUpdatedAt: false,
      typeEmployee: '',
      dialogTotalRent: false,
      totalRent: null,
      loadingTotalRent: false,
    };
  },

  mounted() {
    this.loadCategories();
    this.clearNotes();
    this.countToolsMethod();
    this.countVehiculesMethod();
    this.amountPaymentMethod();
    this.countVehiculeVerifiedMethod();
    //this.findClosings();
    this.countEmployeeMethod();
    this.totalSalaryMethod();
    this.amountRentalMethod();
    this.vehiculeFindAdminMethod();
    this.loadPayrollsTotal();
  },

  computed: {
    categories() {
      return this.$store.getters.getCategory;
    },

    notes() {
      return this.$store.getters.getNotes;
    },

    noteItems() {
      return [];
    },
  },

  watch: {
    categoryName(value) {
      this.categoryName = value.toUpperCase();
    },

    noteName(value) {
      this.noteName = value.toUpperCase();
    },

    noteContent(value) {
      this.noteContent = value.toUpperCase();
    },
  },

  methods: {
    selectCategory(categoryId) {
      this.categoryId = categoryId;
      this.loadingNotes = true;
      setTimeout(() => {
        this.$store.dispatch("findNotesByCategoryAction", {
          category_id: categoryId,
        });
        this.loadingNotes = false;
      }, 500);
    },

    openDialogCategory(schema = "new") {
      if (schema == "new") {
        this.btnCategory = "GUARDAR";
        this.titleDialogCategory = "Registrar categoria";
        this.categoryId = 0;
        this.categoryName = "";
      } else {
        this.btnCategory = "EDITAR";
        this.titleDialogCategory = "Editar categoria";
        let item = this.categories.find((c) => c.id == this.categoryId);
        this.categoryName = item.name;
        this.categoryId = item.id;
      }
      this.dialogCategory = true;
    },

    closeDialogCategory() {
      this.dialogCategory = false;
    },

    processCategory() {
      let payload = {
        name: this.categoryName,
      };
      this.loadingProcessCategory = true;
      setTimeout(() => {
        let path =
          this.categoryId == 0 ? "storeCategoryAction" : "updateCategoryAction";
        if (this.categoryId > 0) payload.id = this.categoryId;
        this.$store
          .dispatch(path, payload)
          .then(() => {
            this.loadingProcessCategory = false;
            this.dialogCategory = false;
            this.clearCategory();
          })
          .catch(() => {
            this.loadingProcessCategory = false;
          });
      }, 500);
    },

    loadCategories() {
      this.loadingCategories = true;
      this.loadedCategories = false;
      setTimeout(() => {
        this.$store
          .dispatch("indexCategoriesAction")
          .then(() => {
            this.loadingCategories = false;
            this.loadedCategories = true;
          })
          .catch(() => {
            this.loadingCategories = false;
          });
      }, 500);
    },

    clearCategory() {
      this.categoryName = "";
    },

    openDialogNote(schema = "new") {
      if (schema == "new") {
        this.visibleNoteUpdatedAt = false;
        this.titleDialogNote = "Registrar nota";
        this.btnDialogNote = "GUARDAR";
        this.isDelete = false;
        this.loadedNote = true;
      } else {
        this.visibleNoteUpdatedAt = true;
        this.titleDialogNote = "Editar nota";
        this.btnDialogNote = "EDITAR";
        this.isDelete = true;
      }
      this.dialogNote = true;
    },

    closeDialogNote() {
      this.dialogNote = false;
      this.clearNote();
    },

    processNote() {
      this.loadingProcessNote = true;
      setTimeout(() => {
        let path =
          this.btnDialogNote == "GUARDAR"
            ? "storeNoteAction"
            : "updateNoteAction";

        let payload = {
          name: this.noteName,
          content: this.noteContent,
          category_id: this.categoryId,
        };

        if (this.btnDialogNote == "EDITAR") {
          payload.id = this.noteId;
          payload.category_id = this.noteCategoryId;
        }

        this.$store
          .dispatch(path, payload)
          .then(() => {
            this.loadingProcessNote = false;
            this.closeDialogNote();
          })
          .catch(() => {
            this.loadingProcessNote = false;
          });
      }, 500);
    },

    changeToList() {
      this.isList = !this.isList;
    },

    selectNote(noteId) {
      this.dialogNote = true;
      this.loadingNote = true;
      this.loadedNote = false;
      setTimeout(() => {
        this.$store.dispatch("showNoteAction", noteId).then((res) => {
          this.noteName = res.name;
          this.noteContent = res.content;
          this.noteUpdateAt = res.updated_at;
          this.btnDialogNote = "EDITAR";
          this.visibleNoteUpdatedAt = true;
          this.noteId = res.id;
          this.noteCategoryId = res.category_id;
          this.isDelete = true;
          this.loadingNote = false;
          this.loadedNote = true;
        });
      }, 500);
    },

    clearNote() {
      this.noteName = "";
      this.noteContent = "";
      this.noteUpdateAt = "";
    },

    clearNotes() {
      this.$store.commit("clearNotes");
    },

    deleteCategory() {
      this.$confirm({
        message: `Quieres eliminar esta categoria?`,
        button: {
          no: "No",
          yes: "Si",
        },
        callback: (confirm) => {
          if (confirm) {
            this.loadingDelete = true;
            setTimeout(() => {
              this.$store
                .dispatch("deleteCategoryAction", this.categoryId)
                .then(() => {
                  this.loadingDelete = false;
                  this.dialogCategory = false;
                });
            }, 500);
          }
        },
      });
    },

    deleteNote() {
      this.$confirm({
        message: `Quieres eliminar esta nota?`,
        button: {
          no: "No",
          yes: "Si",
        },
        callback: (confirm) => {
          if (confirm) {
            this.loadingDeleteNote = true;
            setTimeout(() => {
              this.$store
                .dispatch("deleteNoteAction", this.noteId)
                .then(() => {
                  this.loadingDeleteNote = false;
                  this.dialogNote = false;
                })
                .catch(() => {
                  this.loadingDeleteNote = false;
                });
            }, 500);
          }
        },
      });
    },

    countVehiculesMethod() {
      this.loadingVehiculePrivate = true;
      this.loadingVehiculePublic = true;
      this.loadedVehiculePrivate = false;
      this.loadedVehiculePublic = false;
      setTimeout(() => {
        this.$store.dispatch("countVehiculesAction").then((res) => {
          this.countVehiculePrivate = res.private;
          this.countVehiculePublic = res.public;
          this.loadingVehiculePrivate = false;
          this.loadingVehiculePublic = false;
          this.loadedVehiculePrivate = true;
          this.loadedVehiculePublic = true;
        });
      }, 500);
    },

    countToolsMethod() {
      this.loadingCountTool = true;
      this.loadedCountTool = false;
      setTimeout(() => {
        this.$store.dispatch("countToolsAction").then((res) => {
          this.countTools = res;
          this.loadingCountTool = false;
          this.loadedCountTool = true;
        });
      }, 500);
    },

    amountPaymentMethod() {
      this.loadingAmountReceivable = true;
      this.loadedAmountReceivable = false;
      this.loadingAmountCharge = true;
      this.loadedAmountCharge = false;

      setTimeout(() => {
        this.$store.dispatch("amountPaymentAction").then((payment) => {
          this.amountCharge = new Intl.NumberFormat("es-VE").format(payment);
          this.loadingAmountCharge = false;
          this.loadedAmountCharge = true;

          this.$store.dispatch("amountReceivableAction").then((total) => {
            let amount = total - payment;
            this.amountReceivable = new Intl.NumberFormat("es-VE").format(amount);
            this.loadingAmountReceivable = false;
            this.loadedAmountReceivable = true;
          });
        });
      }, 500);


    },

    countVehiculeVerifiedMethod() {
      this.loadingVerified = true;
      this.loadedVerified = false;
      setTimeout(() => {
        this.$store.dispatch("countVehiculeVerified").then((res) => {
          this.countVehiculeVerified = res;
          this.loadingVerified = false;
          this.loadedVerified = true;
        });
      }, 500);
    },

    openDialogStadits(value) {
      if (value == "tools") {
        this.click_tool++;
        this.valueStadits = value;
        this.dialogTools = true;
      } else if (value == "vehicules_public") {
        this.valueStadits = value;
        this.dialogStadits = true;
      } else {
        this.valueStadits = value;
        this.dialogStadits = true;
      }
      this.click_dash++;
    },

    findClosings() {
      this.$store.dispatch("findClosingsAction").then((res) => {
        this.closings = res;
      });
    },

    openDialogClosing(closingId) {
      this.loadingMovements = true;
      this.loadedMovements = false;
      this.movements = [];
      this.dialogClosing = true;

      setTimeout(() => {
        this.$store
          .dispatch("findListMovementClosingsAction", closingId)
          .then((res) => {
            this.movements = res;
            this.loadingMovements = false;
            this.loadedMovements = true;
          });
      }, 500);
    },

    countEmployeeMethod() {
      this.loadingCountEmployee = true;
      this.loadedCountEmployee = false;
      setTimeout(() => {
        this.$store.dispatch("findCountEmployee").then((res) => {
          this.countEmployees = res
          this.loadingCountEmployee = false;
          this.loadedCountEmployee = true;
        })
      }, 500);
    },

    openDialogEmployees(type) {
      this.click_employee++;
      this.typeEmployee = type;
      this.dialogEmployee = true;
    },

    totalSalaryMethod() {
      this.loadingSalary = true;
      this.loadedSalary = false;
      setTimeout(() => {
        this.$store.dispatch("totalSalaryAction").then((res) => {
          this.totalSalary = new Intl.NumberFormat("es-VE").format(res);
          this.loadingSalary = false;
          this.loadedSalary = true;
        })
      }, 500);
    },

    amountRentalMethod() {
      this.loadingRent = true;
      setTimeout(() => {
        this.$store.dispatch('amountRentalsAction').then((res) => {
          this.amountRent = new Intl.NumberFormat("es-VE").format(res);
          this.loadingRent = false;
          this.loadedRent = true;
        }).catch(() => {
          this.loadingRent = false;
          this.loadedRent = true;
        })
      }, 500);

    },

    vehiculeFindAdminMethod() {
      this.loadingVehiculeFindAdmin = true;
      this.loadedVehiculeFindAdmin = false;
      setTimeout(() => {
        this.$store.dispatch('vehiculeFindAdminAction').then((res) => {
          this.vehiculesFindAdmin = res;
          this.loadedVehiculeFindAdmin = true;
          this.loadingVehiculeFindAdmin = false;
        }).catch(() => {
          this.loadedVehiculeFindAdmin = true;
          this.loadingVehiculeFindAdmin = false;
        })
      }, 500);
    },

    loadPayrollsTotal() {
      this.loadingPayrollsTotal = true;
      this.loadedPayrollsTotal = false;
      setTimeout(() => {
        this.$store.dispatch('loadPayrollsTotalAction').then((res) => {
          this.payrollsTotal = res;
          this.loadingPayrollsTotal = false;
          this.loadedPayrollsTotal = true;
        }).catch(() => {
          this.loadingPayrollsTotal = false;
          this.loadedPayrollsTotal = true;
        })
      }, 500);
    },

    openDialogTotalRent() {
      this.dialogTotalRent = true;
      this.loadingTotalRent = true;

      setTimeout(() => {
        this.$store.dispatch("totalWeekAction").then((res) => {
          this.totalRent = res;
          this.loadingTotalRent = false;
        }).catch(() => {
          this.dialogTotalRent = false;
          this.loadingTotalRent = false;
        })
      }, 500);
    },


    openDialogAdminPayroll() {
      this.dialogAdminPayroll = true;
    },

    closeDialogPayroll() {
      this.dialogAdminPayroll = false;
    },
  },
};
</script>

<style scoped></style>
